const User = () => import(/* webpackChunkName: "User" */ "@/views/users/Users");
const Manage = () => import(/* webpackChunkName: "User Manage" */ "@/views/users/management/UserManage");
const VolkswagenSP = () => import(/* webpackChunkName: "User Manage" */ "@/views/users/management/VolkswagenSP");
const UTPStudents = () => import(/* webpackChunkName: "User Manage" */ "@/views/users/management/UTPStudents");
const Practitioners = () => import(/* webpackChunkName: "User Manage" */ "@/views/users/management/Practitioners");
const Extern = () => import(/* webpackChunkName: "User Manage" */ "@/views/users/management/Extern");
const NewUser = () => import(/* webpackChunkName: "User New" */ "@/views/users/management/UserNew");
const NewExternalUser = () => import(/* webpackChunkName: "User New" */ "@/views/users/management/NewExternalUser");
const UserChart = () => import(/* webpackChunkName: "User Chart" */ "@/views/users/chart/OrgChart");
const Admin = () => import(/* webpackChunkName: "User Admin" */ "@/views/users/UserAdmin");
const Groups = () => import(/* webpackChunkName: "User Groups" */ "@/views/users/groups/Groups");
const Search = () => import(/* webpackChunkName: "User Search" */ "@/views/users/UserSearch");

const userRoutes = [
  {
    path: "user",
    name: "User",
    redirect: {
      name: "User Manage"
    },
    component: User,
    children: [
      {
        path: 'manage',
        name: 'User Manage',
        component: Manage
      },
      {
        path: 'volkswagenSP',
        name: 'Volkswagen SP',
        component: VolkswagenSP
      },
      {
        path: 'utpStudents',
        name: 'UTP Students',
        component: UTPStudents,
      },
      {
        path: 'practitioners',
        name: 'Practitioners',
        component: Practitioners,
      },
      {
        path: 'extern',
        name: 'Extern',
        component: Extern,
      },
      {
        path: 'new',
        name: 'User New',
        component: NewUser
      },
      {
        path: 'edit/:controlNumber',
        name: 'User Edit',
        component: NewUser,
        props: true
      },
      {
        path: 'new/extern',
        name: 'New Extern User',
        component: NewExternalUser
      },
      {
        path: 'edit/extern/:controlNumber',
        name: 'User Extern Edit',
        component: NewExternalUser,
        props: true
      },
      {
        path: 'chart',
        name: 'User Chart',
        component: UserChart
      },
      {
        path: 'admin',
        name: 'User Admin',
        component: Admin
      },
      {
        path: 'groups',
        name: 'User Groups',
        component: Groups
      },
      {
        path: "search",
        name: "User Search",
        component: Search,
        props: route => ({
          return_to_path: route.query.path,
          path_id: route.query.id
        })
      }
    ]
  }
];

export default userRoutes;